import { cn } from "@/lib/utils";
import { TONE_FILL, type Tone } from "./tone";

type Segment = { key: string; value: number; tone: Tone };

/** A thin bar split in proportion to each segment's value; a flat muted bar when all are 0. */
export function SegmentBar({ segments }: { segments: Segment[] }) {
  const total = segments.reduce((sum, s) => sum + s.value, 0);
  if (total === 0) return <div className="h-2 rounded bg-muted" />;
  return (
    <div className="flex h-2 gap-0.5 overflow-hidden rounded">
      {segments
        .filter((s) => s.value > 0)
        .map((s) => (
          <div
            key={s.key}
            className={cn("h-full", TONE_FILL[s.tone])}
            style={{ width: `${(s.value / total) * 100}%` }}
          />
        ))}
    </div>
  );
}
